module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choices"
  }, [_vm._l((_vm.question.answers_multiple), function(choice, choiceIndex) {
    return _c('div', {
      staticClass: "choice",
      class: {
        'selected': choice.selected, 'correct': choice.is_correct && _vm.question.commited, 'incorrect': !choice.is_correct && _vm.question.commited
      }
    }, [_c('button', {
      attrs: {
        "disabled": _vm.question.commited
      },
      on: {
        "click": function($event) {
          _vm.selectMultiAnswer(_vm.question, choiceIndex)
        }
      }
    }, [_vm._v(_vm._s(String.fromCharCode(choiceIndex + 65)))]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(choice.answer)
      }
    })])
  }), _vm._v(" "), (_vm.question.commited && _vm.question.correct && _vm.paid) ? _c('div', {
    staticClass: "congratulations"
  }, [_vm._v("\n    Your answer is correct!\n  ")]) : _vm._e(), _vm._v(" "), (_vm.question.commited && !_vm.question.correct && _vm.paid) ? _c('div', {
    staticClass: "sorry"
  }, [_vm._v("\n    Your answer is incorrect. Correct answer is " + _vm._s(_vm.currentQuestionAnswer) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.question.commited && !_vm.paid) ? _c('div', [_vm._v("Answer submitted. Click Continue to proceed.")]) : _vm._e(), _vm._v(" "), (!_vm.question.commited) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.answerMultipleChoice(_vm.question)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (_vm.question.commited && _vm.question.explanation_input) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.showExplanation = true
      }
    }
  }, [_vm._v("Show Explanation")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf07bb8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/QuizModels/MultipleChoiceMultiAnswer.vue
// module id = 51
// module chunks = 0